import styled from 'styled-components';
import { List } from '../../../../components';

const Products = styled(List)`
  border-radius: 6px;
  border: 1px solid ${props => props.theme.colors.borderGray};
`;

Products.withComponent('ol');

Products.defaultProps = {
  listStyle: 'none',
  mb: 4,
  p: 0
};

export default Products;
